import React from "react";

import { Modal } from "@mui/material";

import { LoadingModalWrapper, LoadingSpinner } from "./styles";

interface LoadingModalProps {
  showing?: boolean;
}

const LoadingModal = ({ showing = false }: LoadingModalProps) => {
  return (
    <Modal hideBackdrop={true} open={showing} data-cy="LoadingModal">
      <LoadingModalWrapper>
        <LoadingSpinner size={32} thickness={2} />
      </LoadingModalWrapper>
    </Modal>
  );
};

export default LoadingModal;
